import { Box, Button, Paper, Typography } from "@mui/material";
import { motion } from "motion/react";
import { Link as RouterLink } from "react-router-dom";
import { motionOptions } from "../K8OperatorConfiguration";
import { Markdown } from "~/components/markdown";
import { IntegrationFormInputs } from "./K8OperatorConfigurationForm";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

interface InstallSectionProps {
  scope: SpaceScope | OrganizationScope;
  integrationId: string;
  instructions: {
    title: string;
    description: string;
  };
  installUrl: string;
  installHost: string;
  token: string;
  reset: () => void;
  updateFlow?: {
    values: IntegrationFormInputs;
    integrationMrn: string;
    integrationId: string;
    token: string;
  };
}

export const K8OperatorInstallationSection = ({
  scope,
  integrationId,
  instructions,
  installUrl,
  installHost,
  token,
  reset,
  updateFlow,
}: InstallSectionProps) => {
  const installScript = instructions.description
    .replace(/\%INSTALL_HOST\%/g, installHost)
    .replace(/\%URL\%/g, installUrl)
    .replace(/\%TOKEN\%/g, token);

  return (
    <Box component={motion.div} {...motionOptions} key="install-section">
      <Paper sx={{ p: 2 }}>
        <Typography variant="h5" fontWeight={700}>
          {instructions.title}
        </Typography>
        <Markdown source={installScript} />
      </Paper>
      {updateFlow ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          {" "}
          <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to={`/space/integrations/kubernetes/${integrationId}?${scope.params}`}
          >
            Done
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
          <Button variant="outlined" color="secondary" onClick={reset}>
            Create another Integration
          </Button>
          <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to={`/space/integrations/add/mondoo/kubernetes/${integrationId}?${scope.params}`}
          >
            Set Policies
          </Button>
        </Box>
      )}
    </Box>
  );
};
